<template>
  <el-dialog
    modal-append-to-body
    class="dialogContainer"
    id="detailDialog"
    :visible.sync="dialogVisible"
    width="40%"
    @close="handleClose"
  >
    <template #title>
      <img src="../../assets/popup_icon.png" alt class="popup_icon" />
      <div class="title">{{ title }}</div>
    </template>

    <SuperviseArrangeDetail
      :detailList="superviseArrangeList"
      :detaildata="detaildata"
      v-if="activeName === 0"
    />
    <EventFlowDetail
      :detailList="eventFlowList"
      :imgList="imglist"
      :timelineList="timelineList"
      v-else-if="activeName === 1"
      @load="load"
    />
    <ExpertInDetail
      :detailObj="detail"
      v-else-if="activeName === 2"
      @load="load"
    />
    <QueryTalkDetail
      :detailObj="detail"
      :questionList="questionList"
      :imgList="imglist"
      v-else-if="activeName === 3"
      @load="load"
    />
    <ResponseDetail
      :detailObj="detail"
      :questionList="questionList"
      :imgList="imglist"
      v-else-if="activeName === 4"
      @load="load"
    />
    <template #footer>
      <span class="bottom" v-if="showItem === '0'">去分享</span>
      <span
        ref="print"
        class="bottom"
        v-print="printObj"
        v-else-if="showItem === '1'"
        >去打印</span
      >
      <span
        class="bottom"
        ref="download"
        @click="ExportSavePdf(htmlTitle, 'nowPrintDetail')"
        v-else-if="showItem === '2'"
        >去下载</span
      >
    </template>
  </el-dialog>
</template>

<script>
import html2canvas from "html2canvas";
import SuperviseArrangeDetail from "../Details/SuperviseArrangeDetail";
import EventFlowDetail from "../Details/EventFlowDetail";
import ExpertInDetail from "../Details/ExpertInDetail";
import QueryTalkDetail from "../Details/QueryTalkDetail";
import ResponseDetail from "../Details/ResponseDetail";
import { dataURLtoFile } from "@/utils/util";
// import { getServerData } from "@/utils/fetchData";
// import { APIMAP } from "@/constants/apiConstants";
import { mapState, mapMutations } from "vuex";

export default {
  name: "DetailDialog",
  components: {
    SuperviseArrangeDetail,
    EventFlowDetail,
    ExpertInDetail,
    QueryTalkDetail,
    ResponseDetail,
  },
  props: {
    title: {
      type: String,
      default: "对话框详情",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    detailList: {
      type: Object,
      default() {
        return {};
      },
    },
    eventFlowList: {
      type: Array,
      default: () => [],
    },
    timelineList: {
      type: Array,
      default: () => [],
    },
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    questionList: {
      type: Array,
      default: () => [],
    },
    imglist: {
      type: Array,
      default: () => [],
    },
    superviseArrangeList: {
      type: Array,
      default: () => [],
    },
    detaildata: {
      type: Object,
      default() {
        return {};
      },
    },
    activeName: {
      type: Number,
      required: true,
    },
    showItem: {
      type: String,
      required: true,
    },
    htmlTitle: {
      type: String,
      default: "事件详情",
    },
  },
  data() {
    return {
      dialogVisible: true,
      operate: ["分享", "打印", "下载"],
      // superviseArrangeList: [],
      // detail: {},
      // questionList: [],
      // imglist: [],
      printObj: {
        id: "nowPrintDetail",
        popTitle: "详情",
      },
      // eventFlowList: [],
      // timelineList: [],
      // stateMap: {
      //   "-2": "被驳回",
      //   "-1": "已删除",
      //   "-3": "退回重做",
      //   "0": "待审核",
      //   "1": "待签批",
      //   "2": "待处理",
      //   "3": "待处罚",
      //   "4": "待扣分",
      //   "5": "待整改",
      //   "6": "申诉待处理",
      //   "7": "待复查",
      //   "8": "待归档",
      //   "9": "已完结",
      //   "10": "去整改",
      //   "11": "住建审核",
      // },
      detailObj: {},
      // htmlTitle: "事件详情",
    };
  },
  mounted() {
    if (this.activeName === 0 || this.imglist.length === 0) {
      if (this.showItem === "0") {
        this.$nextTick(() => {
          this.toShare();
        });
      } else if (this.showItem === "1") {
        this.$nextTick(() => {
          this.$refs.print.click();
          this.dialogVisible = false;
        });
      } else if (this.showItem === "2") {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.download.click();
            this.dialogVisible = false;
          }, 100);
        });
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      isShow: (state) => state.Chat.showChat,
    }),
  },
  methods: {
    ...mapMutations([
      "CHANGE_SHOW_CHAT",
      "CHANGE_FROM_SHARE",
      "CHANGE_NOW_SHARE_PIC",
    ]),
    handleClose() {
      this.$emit("close");
    },
    load() {
      console.log("what do you mean");
      if (this.showItem === "0") {
        this.toShare();
      } else if (this.showItem === "1") {
        this.$refs.print.click();
      } else if (this.showItem === "2") {
        this.$refs.download.click();
      }
      this.dialogVisible = false;
    },
    // 处理督查调令详情数据
    // superviseArrangeDetail() {
    //   const res = this.detailList;
    //   switch (res.reply) {
    //     case 0:
    //       res.reply = "待确认";
    //       break;
    //     case 1:
    //       res.reply = "没有问题";
    //       break;
    //     case 2:
    //       res.reply = "存在问题";
    //       break;
    //     default:
    //       break;
    //   }
    //   const superviseArrangeList = [];
    //   superviseArrangeList.push(
    //     {
    //       name: "监理",
    //       value: res.consupervision,
    //     },
    //     {
    //       name: "甲方",
    //       value: res.conbuilding,
    //     },
    //     {
    //       name: "乙方",
    //       value: res.conconstruction,
    //     },
    //     {
    //       name: "事件类型",
    //       value: res.type === 1 ? "日常调度" : "紧急调度",
    //     },
    //     {
    //       name: "事件编号",
    //       value: res.code,
    //     },
    //     {
    //       name: "工地名称",
    //       value: res.construction,
    //     },
    //     {
    //       name: "工地地址",
    //       value: res.conadress,
    //     },
    //     {
    //       name: "信用等级",
    //       value: res.conlevel,
    //     },
    //     {
    //       name: "历史问题",
    //       value: [
    //         {
    //           name: "整改",
    //           value: res.rectify,
    //         },
    //         {
    //           name: "扣分",
    //           value: res.deduction,
    //         },
    //         {
    //           name: "处罚",
    //           value: res.punishment,
    //         },
    //       ],
    //     },
    //     {
    //       name: "发布人",
    //       value: res.username,
    //     },
    //     {
    //       name: "发布时间",
    //       value: res.releasetime,
    //     },
    //     {
    //       name: "接收调度",
    //       value: res.confirmtime,
    //     },
    //     {
    //       name: "督查时间",
    //       value: res.supervisetime,
    //     },
    //     {
    //       name: "督察小组",
    //       value: res.inspection,
    //     },
    //     {
    //       name: "督查问题",
    //       value: res.reply,
    //     }
    //   );
    //   this.superviseArrangeList = superviseArrangeList;
    //   this.htmlTitle = res.code + res.address;
    // },
    // 处理督查事件详情数据
    // eventFlowDetail() {
    //   const res = this.detailList;
    //   const eventFlowList = [];
    //   eventFlowList.push(
    //     {
    //       name: "上传人员",
    //       type: "uname",
    //       value: res.uname,
    //     },
    //     {
    //       name: "上传时间",
    //       type: "uptime",
    //       value: res.uptime,
    //     },
    //     {
    //       name: "当前状态",
    //       type: "status",
    //       value: this.stateMap[String(res.status)],
    //     },
    //     {
    //       name: "下级流转部门",
    //       type: "receivedept",
    //       value: res.receivedept,
    //     },
    //     {
    //       name: "问题类型",
    //       type: "",
    //       value: JSON.parse(res.putype),
    //     },
    //     {
    //       name: "问题描述",
    //       type: "",
    //       value: "",
    //     }
    //   );
    //   this.imglist = res.p3;
    //   this.eventFlowList = eventFlowList;
    //   this.getEventFlowDetai();
    // },
    // 获取督查事件详情数据
    // async getEventFlowDetai() {
    //   try {
    //     const params = {};
    //     params.gid = this.gid;
    //     params.eid = this.userInfo.eid;
    //     console.log("请求参数", params);
    //     const res = await getServerData(APIMAP.EVENT + `/${this.gid}`, params);
    //     console.log("返回数据", res);
    //     this.htmlTitle = res.master.code + res.master.address;
    //     const { slave } = res;
    //     if (slave && slave.length) {
    //       this.timelineList = slave;
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // 获取介入事件详情数据
    // async getExpertInDetail() {
    //   try {
    //     const params = {};
    //     params.gid = this.gid;
    //     console.log("请求参数", params);
    //     const res = await getServerData(
    //       APIMAP.EXPERTINTERVENTION + `/${this.gid}`,
    //       params
    //     );
    //     console.log("返回数据", res);
    //     if (res.imgurl) {
    //       res.imgurl = res.imgurl.split("|");
    //     }
    //     this.detailObj = res;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // 获取约谈事件详情数据
    // async getQueryTalkDetail() {
    //   try {
    //     const params = {};
    //     params.gid = this.gid;
    //     console.log("请求参数", params);
    //     const res = await getServerData(
    //       APIMAP.INTERVIEW + `/${this.gid}`,
    //       params
    //     );
    //     console.log("返回数据", res);
    //     this.htmlTitle = res.eventcode + res.object;
    //     this.fmtdetail(res);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // // 获取追责事件详情数据
    // async getResponseDetail() {
    //   try {
    //     const res = await getServerData(
    //       APIMAP.INTERVIEW + "/" + this.gid,
    //       {
    //         gid: this.gid,
    //       },
    //       "get"
    //     );
    //     console.log("追责详情", res);
    //     this.htmlTitle = res.eventcode + res.object;
    //     this.fmtdetail(res);
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    // fmtdetail(data) {
    //   var qlist = data.reasondetail.split(";");
    //   this.detail = data;
    //   this.questionList = qlist;
    //   if (data.status == 1) {
    //     this.imglist = data.imgurl && data.imgurl.split("|");
    //     console.log(this.imglist);
    //   }

    //   this.$refs.print.click();
    //   // this.dialogVisible = false;
    // },
    // 判断
    // decide() {
    //   switch (this.activeName) {
    //     case 0:
    //       this.superviseArrangeDetail();
    //       break;
    //     case 1:
    //       this.eventFlowDetail();
    //       break;
    //     case 2:
    //       this.getExpertInDetail();
    //       break;
    //     case 3:
    //       this.getQueryTalkDetail();
    //       break;
    //     case 4:
    //       this.getResponseDetail();
    //       break;
    //     default:
    //       break;
    //   }
    // },
    // 分享
    toShare() {
      // this.sharePng("#nowPrintDetail");
      html2canvas(document.querySelector("#nowPrintDetail"), {
        logging: false, // 是否启用日志
        allowTaint: true, // 是否允许跨域渲染
        useCORS: true, // 是否尝试使用CORS从服务器加载图像
        // proxy: 'https://cache.onefoot365.com'
      })
        .then((canvas) => {
          const file = canvas.toDataURL("image/jpeg");
          const blob = dataURLtoFile(file);
          console.log(blob, file);
          this.CHANGE_NOW_SHARE_PIC(blob);
          this.CHANGE_SHOW_CHAT(true);
          this.CHANGE_FROM_SHARE(true);
          this.dialogVisible = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "分享异常，请刷新后重试",
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
.dialogContainer {
  .popup_icon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 12px;
  }
  .title {
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    color: #2c3a50;
    letter-spacing: 2px;
  }

  .bottom {
    font-size: 15px;
    color: #969aa5;
    letter-spacing: 1px;
    margin-right: 15px;
    cursor: pointer;
  }
  .bottom:hover {
    font-weight: 600;
    color: var(--themeColor);
  }
}
</style>